import { FileType } from "@nestcoinco/hyper-api-gateway-api-client";

const DEFAULT_APK = {
  id: "",
  url: "https://hyper-production.mvm.gg/apk/hyper-app-237.apk",
  type: FileType.APK,
  isPublic: true,
  version: 237,
};

export default DEFAULT_APK;
